import { getRecentComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import { Link } from 'react-router-dom';

export default function RecentUpdates() {
  const recentComics = getRecentComics(4);

  return (
    <section className="py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最近更新</h2>
            <p className="mt-2 text-foreground-500 text-sm">刚刚更新的韩漫作品，第一时间追更</p>
          </div>
          <Link
            to="/category/mianfei-wuzhe"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            更多作品 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-product-shop>
          {recentComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}